module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item column",
    class: {
      red: (_vm.prog < 0)
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-values row"
  }, [(_vm.title !== 'Mes revenus perçus depuis que je suis client') ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.prog) + " %\n      ")]) : _vm._e(), _vm._v(" "), (_vm.title === 'Mes revenus perçus depuis que je suis client') ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.formatCurrency(_vm.prog)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "prog"
  }, [((_vm.prog >= 0)) ? _c('span', [_c('img', {
    attrs: {
      "src": _vm.good,
      "alt": ""
    }
  })]) : _c('span', [_c('img', {
    attrs: {
      "src": _vm.bad,
      "alt": ""
    }
  })])])]), _vm._v(" "), (_vm.title !== 'Mes revenus perçus depuis que je suis client') ? _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "inner-bar",
    style: ({
      width: Math.abs(_vm.prog) + '%'
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.title === 'Mes revenus perçus depuis que je suis client') ? _c('div', {
    staticClass: "dot",
    attrs: {
      "id": "global-perf-help-modal"
    },
    on: {
      "click": _vm.toggleGlobalPerfHelpModal
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24b64dfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/performance-stat.vue
// module id = 1085
// module chunks = 0